require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./basics-guide-react-native.json") })
        }
      }, "path---basics-guide-react-native");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---basics-guide-react-native!./.cache/json/basics-guide-react-native.json
// module id = 407
// module chunks = 231608221292675